export default function Footer() {
  return (
    <footer className="mt-16 border-t border-orange-100 bg-gradient-to-b from-orange-50 to-white">
      
      {/* TOP FOOTER CONTENT */}
      <div className="max-w-6xl mx-auto px-4 py-10 grid gap-6 md:grid-cols-3">
        <div>
          <h3 className="font-semibold text-slate-800">La Voie Lactée</h3>
          <p className="text-sm text-slate-600 mt-2">
            École primaire active spécialisée située dans l'écoquartier des Vergers à Meyrin.
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-slate-800">Liens utiles</h3>
          <ul className="mt-2 space-y-1 text-sm text-slate-600">
            <li>
              <a
                className="hover:underline"
                href="https://procert.ch/presentation/presentation.php?lang=fr"
                target="_blank"
                rel="noreferrer"
              >
                Certification Qualité
              </a>
            </li>
            <li>
              <a
                className="hover:underline"
                href="https://agoeer.ch/"
                target="_blank"
                rel="noreferrer"
              >
                AGOEER
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-slate-800">Contact</h3>
          <p className="text-sm text-slate-600 mt-2">
            Écoquartier des Vergers, Meyrin (Genève)
          </p>
        </div>
      </div>

      {/* FULL WIDTH BOTTOM BAR */}
      <div className="border-t border-gray-800">
        <div className="max-w-6xl mx-auto px-4 py-6 text-gray-400">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center text-center md:text-left gap-4">
            <p className="text-sm">
              © 2025 La Voie Lactée. All rights reserved.
            </p>

            <span className="text-sm">
              Developed and maintained with ❤️ by{" "}
              <a
                href="https://ai.hridx.tech/"
                className="text-red-400 underline underline-offset-4 font-semibold"
              >
                HridxAI...
              </a>
            </span>
          </div>
        </div>
      </div>

    </footer>
  );
}
